/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Saveperyearwithyearly4Inputs */

const en_saveperyearwithyearly4 = /** @type {(inputs: Saveperyearwithyearly4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Save ${i?.amount} per year with yearly billing`)
};

const de_saveperyearwithyearly4 = /** @type {(inputs: Saveperyearwithyearly4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spare ${i?.amount} pro Jahr mit jährlicher Abrechnung`)
};

/**
* | output |
* | --- |
* | "Save {amount} per year with yearly billing" |
*
* @param {Saveperyearwithyearly4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const saveperyearwithyearly4 = /** @type {((inputs: Saveperyearwithyearly4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Saveperyearwithyearly4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_saveperyearwithyearly4(inputs)
	return de_saveperyearwithyearly4(inputs)
});
export { saveperyearwithyearly4 as "savePerYearWithYearly" }